export default __webpack_public_path__ + "static/media/js.4b0c5805.png";